module.exports = __webpack_public_path__ + "media/images/icons/globe-0fee4f1816b02008b5a6316cb6ab70f7.svg";